import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/index',
      component: (resolve) => require(['@/views/Layout'], resolve),
    },
    {
      path: '/current_weather',
      component: (resolve) => require(['@/views/current_weather/current_weather'], resolve),
      meta: {
        title: '本地天气',
      },
    },
    {
      path: '/weather_monitor/:id',
      component: (resolve) => require(['@/views/weather_monitor/weather_monitor'], resolve),
    },
    {
      path: '/warn',
      component: (resolve) => require(['@/views/warninfo/warninfo'], resolve),
      meta: {
        title: '预警信号',
      },

    },
    {
      path: '/pushMsg',
      component: (resolve) => require(['@/views/pushMsg/sendPush'], resolve),
      meta: {
        title: '公众号推送消息',
      },
    },
    {
      path: '/weather_certificate',
      component: (resolve) => require(['@/views/weather_certificate/weather_certificate'], resolve),
      meta: {
        title: '公众互动',
      },
    },
    {
      path: '/weather_certificate/apply',
      component: (resolve) => require(['@/views/weather_certificate/Apply'], resolve),
      meta: {
        title: '证明申请',
      },
    },
    {
      path: '/weather_certificate/apply_result',
      component: (resolve) => require(['@/views/weather_certificate/ApplyResult'], resolve),
      meta: {
        title: '提交反馈',
      },
    },
    {
      path: '/weather_certificate/apply_details/:id',
      component: (resolve) => require(['@/views/weather_certificate/applyDetails'], resolve),
      meta: {
        title: '气象证明详情',
      },
    },

  ],
});
router.beforeEach((to: any, from, next) => {
    // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router
